import type { FC, ReactNode } from "react";
import MenuRounded from "@mui/icons-material/MenuRounded";
import { AppBar, Badge, IconButton, Stack, Toolbar } from "@mui/material";

export interface HeaderProps {
  onMenuToggle: () => void;
  accountMenu?: ReactNode;
  needOnboarding?: boolean;
}

export const Header: FC<HeaderProps> = ({
  onMenuToggle,
  accountMenu,
  needOnboarding,
}) => {
  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={({ palette }) => ({
          display: { lg: "none", sm: "flex" },
          borderBottom: `1px solid ${palette.divider}`,
        })}
      >
        <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Stack direction="row" gap={{ xs: 1, sm: 3 }}>
            <Badge
              badgeContent={needOnboarding ? "!" : null}
              color="primary"
              overlap="circular"
            >
              <IconButton
                size="medium"
                edge="start"
                sx={{
                  color: "text.secondary",
                  display: { xs: "flex", lg: "none" },
                }}
                onClick={onMenuToggle}
              >
                <MenuRounded />
              </IconButton>
            </Badge>
            {/* <Logo /> */}
          </Stack>

          {accountMenu}
        </Toolbar>
      </AppBar>
      <Toolbar sx={{ display: { lg: "none" } }} />
    </>
  );
};
